module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pane"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("London Terror Attack")]), _vm._v(" "), _c('div', {
    staticClass: "intro-text"
  }, [_c('p', [_vm._v("\n          Horrific news continues to come out of London days after fanatics unleashed terror into the heart of the city, mowing down pedestrians in a van then rampaging on foot through a packed nightlife area. Eight innocents were killed - among them two Australians - and 48 injured. This interactive shows the route the three attackers took and places they targeted, in 360-vision with witness footage from the scene.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "start-button",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('img', {
    staticClass: "intro-logo",
    attrs: {
      "src": require("../../static/images/logo.png")
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pane left-pane"
  }, [_c('img', {
    staticClass: "intro-image",
    attrs: {
      "src": require("../../static/images/intro.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ea3838"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 130
// module chunks = 1